document.addEventListener('DOMContentLoaded', function () {

  // ── HAMBURGER MENU ──
  const menuOpen = document.getElementById('menu-open');
  const menuClose = document.getElementById('menu-close');
  const menuPanel = document.getElementById('menu-panel');
  const menuOverlay = document.getElementById('menu-overlay');
  const mainNav = document.getElementById('main-nav');

  if (menuOpen && menuPanel) {
    function openMenu() {
      menuPanel.classList.add('open');
      if (menuOverlay) menuOverlay.classList.add('open');
      if (mainNav) mainNav.classList.add('menu-active');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      menuPanel.classList.remove('open');
      if (menuOverlay) menuOverlay.classList.remove('open');
      if (mainNav) mainNav.classList.remove('menu-active');
      document.body.style.overflow = '';
    }

    menuOpen.addEventListener('click', openMenu);
    if (menuClose) menuClose.addEventListener('click', closeMenu);
    if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  // ── MOBILE GALLERY DOTS ──
  const gallery = document.getElementById('gallery');
  const dots = document.querySelectorAll('.gallery-dot');

  if (gallery && dots.length) {
    function updateDots() {
      const index = Math.round(gallery.scrollLeft / gallery.offsetWidth);
      dots.forEach(function (d, i) { d.classList.toggle('active', i === index); });
    }

    gallery.addEventListener('scroll', updateDots, { passive: true });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        gallery.scrollTo({ left: parseInt(dot.dataset.index) * gallery.offsetWidth, behavior: 'smooth' });
      });
    });
  }

  // ── COLOR SWATCHES ──
  document.querySelectorAll('.color-swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      document.querySelectorAll('.color-swatch').forEach(function (s) { s.classList.remove('active'); });
      swatch.classList.add('active');
      var label = document.getElementById('color-name');
      if (label) label.textContent = swatch.dataset.name;

      // Shopify: update hidden variant id based on selected color
      var variantInput = document.getElementById('variant-id');
      if (variantInput && window.__LN_variants) {
        var match = window.__LN_variants.find(function (v) {
          return v.option1 && v.option1.toLowerCase() === swatch.dataset.color;
        });
        if (match) variantInput.value = match.id;
      }
    });
  });

});

// ── ACCORDION ──
function toggleAccordion(header) {
  var body = header.nextElementSibling;
  var icon = header.querySelector('.accordion-icon');
  var isOpen = body.classList.contains('open');
  document.querySelectorAll('.accordion-body').forEach(function (b) { b.classList.remove('open'); });
  document.querySelectorAll('.accordion-icon').forEach(function (i) { i.textContent = '+'; });
  if (!isOpen) {
    body.classList.add('open');
    if (icon) icon.textContent = '−';
  }
}
